/* eslint-disable no-unused-vars */
import React from 'react';
import Header from '../header/header';
import Footer from '../footer/footer';
// eslint-disable-next-line no-lone-blocks
import ImageSlider from '../apropos/halloween/carrousselhalloween';

const Ateliers = (props) => {

  return (
    <div>  
            <Header />

    <div id="activites">

      <div className="container">
                   <div className="col-xs-12 col-md-12">

<br></br>
<br></br>
        <div className="section-title">
          <h2>Les ateliers</h2>
          <br></br>
              <br></br>
                    <br></br>
                     <div className="activites-list" >
 <p>
            Fleuriste passionnée à Chennevières-sur-Marne, Je vous propose
            des ateliers floraux sur mesure.
            Ces ateliers sont conçus pour offrir un moment de créativité,
            de partage et de découverte autour des fleurs et du végétal.
          </p>
<br></br>
          <h4>Des ateliers adaptés à tous les publics</h4>

          <p>
            Je me déplace directement dans vos structures : crèches, écoles,
            maisons de retraite, associations et entreprises. Chaque atelier
            est adapté en fonction des participants afin de proposer une
            expérience accessible, ludique et enrichissante.
          </p>

          <ul  className='libouquets'>
            <li>Ateliers en crèches et écoles</li>
            <li>Animations en maisons de retraite</li>
            <li>Team building en entreprise</li>
            <li>Ateliers créatifs associatifs</li>
          </ul>
<br></br>
          <h4>Créations florales et activités proposées</h4>

          <p>
            Les participants découvrent l’art floral à travers différentes
            activités : création de bouquets, compositions florales,
            centres de table ou décorations avec des fleurs de saison.
          </p>

          <p>
            Chaque atelier est un moment convivial favorisant le lien social,
            la créativité et le bien-être, dans une démarche de proximité
            et d’écoute.
          </p>
<br></br>
          <h4>Ateliers floraux dans le Val-de-Marne (94)</h4>

          <p>
            Les ateliers sont proposés à Chennevières-sur-Marne et dans les
            villes alentours : Saint-Maur-des-Fossés, Sucy-en-Brie,
            Ormesson-sur-Marne et plus largement dans le Val-de-Marne.
            Je peux aussi me déplacer en Ile de France.
          </p>

          <p>
            Tous les ateliers sont réalisés sur réservation uniquement,
            avec du matériel et des fleurs soigneusement sélectionnés et fournis.
          </p>

      <br></br>

<br></br>


{/* <ImageSlider /><br></br><br></br>
  <p>
        🌸 Nouveau chez DELPHIA PAUL !
      </p>
      <p>
       Je suis heureuse de vous présenter mes Ateliers Floraux, pensés pour les enfants, adultes et seniors. 💐
      </p>    
<p>Des moments créatifs et conviviaux pour créer, partager et apprendre autour des fleurs. 🌷✨
</p>
<br></br>
   <p>📩 Informations & réservations en message privé</p>
      <p>📞 06 25 00 67 53</p> */}
<br></br>
<br></br>
      </div>
      </div>
      </div>
  </div>
  </div>
      < Footer />

    </div>

  );
};
export default Ateliers;